import React from 'react';
import { Alert, Tag, Descriptions, Button } from 'antd';
import { FcInfo } from 'react-icons/fc';
import moment from 'moment';

import { urgencyDegree, getMaintenanceTypeLabel } from 'src/utils/constants/tasks';
import { hasMissingRequiredTaskFields } from 'src/utils';

import { IProps } from './descriptions.type';
import { Title } from './descriptions.style';

const UpdateComponent: React.FC<IProps> = (props) => {
  const { task, handleEditing } = props;
  const missingRequiredFields = hasMissingRequiredTaskFields(task);

  return (
    <>
      {missingRequiredFields && (
        <Alert
          className="mb-3"
          type="warning"
          showIcon
          message="Esta OS foi criada com dados obrigatórios pendentes."
          description='Clique em "ADICIONAR DADOS" para informar os dados obrigatórios antes de continuar o fluxo.'
        />
      )}
      <Descriptions
        bordered
        title={
          <Title>
            <FcInfo size={20} className="me-2" />
            <h4 className="m-0">Informações</h4>
          </Title>
        }
        size="small"
        extra={
          <Button
            size="small"
            type={missingRequiredFields ? 'primary' : 'default'}
            onClick={handleEditing}
            disabled={task.stage === 2}
          >
            <small>{missingRequiredFields ? 'ADICIONAR DADOS' : 'EDITAR'}</small>
          </Button>
        }
      >
        <Descriptions.Item span={3} label="Descrição">
          {task.description}
        </Descriptions.Item>
        <Descriptions.Item span={2} label="Setor">
          <b>{task.sector?.name || 'Não informado'}</b>
        </Descriptions.Item>
        <Descriptions.Item span={1} label="Célula">
          <b>{task.cell?.name || 'Não informada'}</b>
        </Descriptions.Item>
        <Descriptions.Item span={3} label="Patrimônio">
          <p className="mb-1">
            <b>Número:</b> {task?.patrimony?.number}
          </p>
          <p className="mb-1">
            <b>Descrição:</b> {task?.patrimony?.description || 'N/A'}
          </p>
          <p className="mb-1">
            <b>Modelo:</b> {task?.patrimony?.model || 'N/A'}
          </p>
          <p className="mb-1">
            <b>Serial Number:</b> {task?.patrimony?.serialNumber || 'N/A'}
          </p>
        </Descriptions.Item>
        <Descriptions.Item span={3} label="Urgência">
          <Tag color={urgencyDegree[task.urgencyDegree].color}>
            {urgencyDegree[task.urgencyDegree]?.icon}
            <b>{urgencyDegree[task.urgencyDegree].label}</b>
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item span={3} label="Tipo de Manutenção">
          <b>{getMaintenanceTypeLabel(task.maintenanceType)}</b>
        </Descriptions.Item>
        <Descriptions.Item span={3} label="Operador">
          {task.operator?.name || 'Não informado'}
        </Descriptions.Item>
        <Descriptions.Item span={2} label="Data/hora da ocorrência">
          <b>{moment(task.occurredAt).format('DD/MM/YY')} </b>
          às
          <b> {moment(task.occurredAt).format('HH:mm')}</b>
        </Descriptions.Item>
        <Descriptions.Item span={2} label="Responsável">
          {task.user?.name || 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default UpdateComponent;
